import {
  GetSurveyAnswerParams,
  PutSurveyAnswerParams,
  deleteFileParams,
  getSurveyParameters,
} from "../Constants/HandlerTypes";
export const Resource = {
  url: {
    getAnswer: (
      surveyAnswerDocId: GetSurveyAnswerParams["surveyAnswerDocId"]
    ) => `/survey-response?surveyAnswerDocId=${surveyAnswerDocId}`,
    survey: (surveyId: string) =>
      `/survey-response/survey?surveyId=${surveyId}`,
    putAnswer: (id?: PutSurveyAnswerParams["surveyAnswerDocId"]) =>
      `/survey-response/${id}`,
    fileUpload: `/survey-response/fileUpload`,
    deleteFile: (deleteParams: deleteFileParams["deleteParams"]) =>
      `/survey-response/delete-file/${deleteParams.docId}?questionId=${deleteParams.questionId}&fileKey=${deleteParams.key}`,
    deleteMultipleFiles: `/survey-response/dependency/file/delete`,
    mfaEmail: (documentId: string) =>
      `/survey-response/check-mfa?documentId=${documentId}`,
    verifyOTP: `/survey-response/mfa/verification`,
    ResendOTP: "/survey-response/resend/mfa-code",
    getBaseSurvey: (
      baseSurveyId: getSurveyParameters["baseSurveyId"],
      companyId: getSurveyParameters["companyId"],
      supplierId: getSurveyParameters["supplierId"]
    ) =>
      `/survey-response/base-tagged-survey-answers?baseSurveyId=${baseSurveyId}&companyId=${companyId}&supplierId=${supplierId}`,
  },
};
